module.exports = "/_next/static/images/e1c9ae724f24f63a5af5552190cbc403-mastercard-lg.jpg.webp";